import { mapState } from "vuex";

import product from "./product";
import reports from "./reports";
import sales from "./sales";
import tools from "./tools";
import automations from "./tools_automations";
import emailMarketing from "./tools_email_marketing";
import invoices from "./tools_invoices";
import members from "./tools_members";
import mecCertifications from "./tools_mec_certifications";

export default {
  mixins: [
    product,
    tools,
    reports,
    sales,
    automations,
    emailMarketing,
    invoices,
    members,
    mecCertifications
  ],
  computed: {
    ...mapState("events", ["lot"]),
    ROUTE_MAP() {
      return {
        "user-personal-data": {
          title: "Dados pessoais"
        },
        "user-financial-data": {
          title: "Dados financeiros"
        },
        "new-bank-account": {
          title: "Nova conta bancária"
        },
        // PRODUTOS
        ...this.productRoutes,

        //RELATÓRIOS
        ...this.reportsRoutes,

        // PRÓXIMOS LANÇAMENTOS
        releases: {
          name: "releases",
          title: "Próximos lançamentos"
        },
        "register-releases": {
          name: "register-releases",
          title: "Novo lançamento",
          params: { id: this.$route.params.id }
        },

        // SALDO
        balance: {
          title: "Saldo"
        },

        // FERRAMENTAS
        ...this.toolsRoutes,

        //AUTOMAÇÕES
        ...this.automationsRoutes,

        //E-MAIL MARKETING
        ...this.emailMarketingRoutes,

        //NOTAS FISCAIS
        ...this.invoicesRoutes,

        //ÁREA DE MEMBROS
        ...this.membersRoutes,

        //MEC CERTIFICAÇÕES
        ...this.mecCertificationsRoutes,

        // VENDAS
        ...this.salesRoutes
      };
    },
    breadcrumbs() {
      if (this.$route.name === "home")
        return [{ name: "home", title: "Início" }];

      if (!this.$route.meta.breadcrumbs) return [];

      return [
        { name: "home", title: "Início" },
        ...this.$route.meta.breadcrumbs.map(name => ({
          name,
          ...this.ROUTE_MAP[name]
        }))
      ];
    }
  }
};
